
import { useState } from "react";
import { Menu, Package, Plus, List, BarChart3, Search, Scan, Users, Clock, Archive, Truck, FileBarChart, TrendingUp } from "lucide-react";
import { Button } from "@/components/ui/button";

interface AdminMobileMenuProps {
  onNewOrder: () => void;
  onViewBackend: () => void;
  onPriceCheck: () => void;
  onScannerTest: () => void;
  onEmployeeManagement: () => void;
  onEmployeeClockIn: () => void;
  onMasterProducts: () => void;
  onSuppliersManagement: () => void;
  onCreditReports: () => void;
  onCostMonitor: () => void;
}

export const AdminMobileMenu = ({
  onNewOrder,
  onViewBackend,
  onPriceCheck,
  onScannerTest,
  onEmployeeManagement,
  onEmployeeClockIn,
  onMasterProducts,
  onSuppliersManagement,
  onCreditReports,
  onCostMonitor
}: AdminMobileMenuProps) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <>
      {/* Mobile Menu Button */}
      <Button
        variant="ghost"
        size="icon"
        className="md:hidden"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      >
        <Menu className="h-5 w-5" />
      </Button>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-16 left-0 right-0 border-t bg-white py-4 shadow-xl z-50 max-h-96 overflow-y-auto">
          <div className="space-y-1"  onClick={() => setIsMobileMenuOpen(false)}>
            <div className="px-4 py-2 text-sm font-medium text-gray-700 flex items-center space-x-2">
              <Package className="h-4 w-4" />
              <span>Orders</span>
            </div>
            <button
              onClick={() => { onNewOrder(); setIsMobileMenuOpen(false); }}
              className="flex items-center space-x-2 px-6 py-2 text-sm text-gray-600 hover:bg-gray-100 w-full text-left"
            >
              <Plus className="h-4 w-4" />
              <span>New Order Check-in</span>
            </button>
            <button
              onClick={() => { onViewBackend(); setIsMobileMenuOpen(false); }}
              className="flex items-center space-x-2 px-6 py-2 text-sm text-gray-600 hover:bg-gray-100 w-full text-left"
            >
              <List className="h-4 w-4" />
              <span>View All Orders</span>
            </button>
            
            <div className="px-4 py-2 text-sm font-medium text-gray-700 border-t flex items-center space-x-2">
              <BarChart3 className="h-4 w-4" />
              <span>Inventory</span>
            </div>
            <button
              onClick={() => { onPriceCheck(); setIsMobileMenuOpen(false); }}
              className="flex items-center space-x-2 px-6 py-2 text-sm text-gray-600 hover:bg-gray-100 w-full text-left"
            >
              <Search className="h-4 w-4" />
              <span>Price Check</span>
            </button>
            <button
              onClick={() => { onScannerTest(); setIsMobileMenuOpen(false); }}
              className="flex items-center space-x-2 px-6 py-2 text-sm text-gray-600 hover:bg-gray-100 w-full text-left"
            >
              <Scan className="h-4 w-4" />
              <span>Scanner Test Lab</span>
            </button>
            
            <div className="px-4 py-2 text-sm font-medium text-gray-700 border-t flex items-center space-x-2">
              <Archive className="h-4 w-4" />
              <span>Products</span>
            </div>
            <button
              onClick={() => { onMasterProducts(); setIsMobileMenuOpen(false); }}
              className="flex items-center space-x-2 px-6 py-2 text-sm text-gray-600 hover:bg-gray-100 w-full text-left"
            >
              <Archive className="h-4 w-4" />
              <span>Master Products</span>
            </button>

            <div className="px-4 py-2 text-sm font-medium text-gray-700 border-t flex items-center space-x-2">
              <Users className="h-4 w-4" />
              <span>Management</span>
            </div>
            <button
              onClick={() => { onSuppliersManagement(); setIsMobileMenuOpen(false); }}
              className="flex items-center space-x-2 px-6 py-2 text-sm text-gray-600 hover:bg-gray-100 w-full text-left"
            >
              <Truck className="h-4 w-4" />
              <span>Suppliers</span>
            </button>
            <button
              onClick={() => { onCreditReports(); setIsMobileMenuOpen(false); }}
              className="flex items-center space-x-2 px-6 py-2 text-sm text-gray-600 hover:bg-gray-100 w-full text-left"
            >
              <FileBarChart className="h-4 w-4" />
              <span>Credit Reports</span>
            </button>
            <button
              onClick={() => { onCostMonitor(); setIsMobileMenuOpen(false); }}
              className="flex items-center space-x-2 px-6 py-2 text-sm text-gray-600 hover:bg-gray-100 w-full text-left"
            >
              <TrendingUp className="h-4 w-4" />
              <span>Cost Monitor</span>
            </button>
            
            <div className="px-4 py-2 text-sm font-medium text-gray-700 border-t flex items-center space-x-2">
              <Users className="h-4 w-4" />
              <span>Staff</span>
            </div>
            <button
              onClick={() => { onEmployeeManagement(); setIsMobileMenuOpen(false); }}
              className="flex items-center space-x-2 px-6 py-2 text-sm text-gray-600 hover:bg-gray-100 w-full text-left"
            >
              <Users className="h-4 w-4" />
              <span>Employee Management</span>
            </button>
            <button
              onClick={() => { onEmployeeClockIn(); setIsMobileMenuOpen(false); }}
              className="flex items-center space-x-2 px-6 py-2 text-sm text-gray-600 hover:bg-gray-100 w-full text-left"
            >
              <Clock className="h-4 w-4" />
              <span>Employee Clock-in</span>
            </button>
          </div>
        </div>
      )}
    </>
  );
};
